import { breakpoints } from '../constants/breakPoints'
import { isDesktop, isMobile } from '../helpers/common'
import common from '../lang/common.json'
// homepage videos
import insightsVideoMP4 from '../video/product/insights.mp4'
import insightsVideoWebm from '../video/product/insights.webm'
import okrVideoMP4 from '../video/product/objectives/okr-hero.mp4'
import okrVideoWebm from '../video/product/objectives/okr-hero.webm'
import portalVideoMP4 from '../video/product/portal.mp4'
import portalVideoWebm from '../video/product/portal.webm'
import prioritizationVideoMP4 from '../video/product/prioritization.mp4'
import prioritizationVideoWebm from '../video/product/prioritization.webm'
import roadmapsVideoMP4 from '../video/product/roadmaps.mp4'
import roadmapsVideoWebm from '../video/product/roadmaps.webm'
//
// the-airfocus-way videos
import groupFeaturesVideoMP4 from '../video/the-airfocus-way/group-features.mp4'
import groupFeaturesVideoWebm from '../video/the-airfocus-way/group-features.webm'
import portfolioVideoMP4 from '../video/the-airfocus-way/portfolio.mp4'
import portfolioVideoWebm from '../video/the-airfocus-way/portfolio.webm'
import prioritizeInclusiveVideoMP4 from '../video/the-airfocus-way/prioritize-inclusive.mp4'
import prioritizeInclusiveVideoWebm from '../video/the-airfocus-way/prioritize-inclusive.webm'
import roadmapViewsVideoMP4 from '../video/the-airfocus-way/roadmap-views.mp4'
import roadmapViewsVideoWebm from '../video/the-airfocus-way/roadmap-views.webm'
import timelineBoardVideoMP4 from '../video/the-airfocus-way/timeline-board.mp4'
import timelineBoardVideoWebm from '../video/the-airfocus-way/timeline-board.webm'
import { videoGalleryBreakPoint } from './breakPoints'

// export for VideoGallery.tsx component
export interface GalleryVideoItemProps {
  title: { en: string; fr?: string; de?: string }
  description?: { en: string; fr?: string; de?: string }
  linkText?: { en: string; fr?: string; de?: string }
  linkURL?: { en: string; fr?: string; de?: string }
  imgSrc?: string
  withoutBorder?: boolean
  mp4VideoSrc: string
  webmVideoSrc: string
  videoRatio: number
  duration: number
}

export const homepageVideos: GalleryVideoItemProps[] = [
  {
    title: {
      en: 'OBJECTIVES & OKRs',
      fr: 'OBJECTIFS & OKRs',
      de: 'OBJECTIVES & OKRs',
    },
    description: {
      en: 'Supercharge your product <br class="hide-on-medium" /> strategy with built-in OKRs',
      fr: 'Renforcez votre stratégie produit <br class="hide-on-medium-large" /> avec des OKR intégrés',
      de: 'Meistere Produktstrategie <br class="hide-on-medium" /> mit eingebauten OKRs',
    },
    linkText: common.learnMoreText,
    linkURL: {
      en: '/product/objectives-okrs/',
      fr: '/fr/product/objectives-okrs/',
      de: '/de/product/objectives-okrs/',
    },
    mp4VideoSrc: okrVideoMP4,
    webmVideoSrc: okrVideoWebm,
    videoRatio: 1.756363636,
    duration: 14.085,
  },
  {
    title: { en: 'ROADMAPS', fr: 'ROADMAPS', de: 'ROADMAPS' },
    description: {
      en: 'Align your team <br class="hide-on-medium" /> and set a clear direction',
      fr: 'Alignez les équipes et <br class="hide-on-medium" /> définissez une stratégie claire',
      de: 'Richte dein Team <br class="hide-on-small-medium" /> auf ein klares Ziel aus',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/roadmaps/', fr: '/fr/product/roadmaps/', de: '/de/product/roadmaps/' },
    mp4VideoSrc: roadmapsVideoMP4,
    webmVideoSrc: roadmapsVideoWebm,
    videoRatio: 1.756363636,
    duration: 7.52,
  },
  {
    title: { en: 'PRIORITIZATION', fr: 'PRIORISATION', de: 'PRIORISIERUNG' },
    description: {
      en: 'Prioritize with confidence and <br class="hide-on-medium" /> make better product decisions',
      fr: 'Priorisez sereinement pour de <br class="hide-on-medium" /> meilleures décisions produit',
      de: 'Priorisiere mit Selbstvertrauen <br class="hide-on-medium" /> und triff bessere Entscheidungen',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/prioritization/', fr: '/fr/product/prioritization/', de: '/de/product/prioritization/' },
    mp4VideoSrc: prioritizationVideoMP4,
    webmVideoSrc: prioritizationVideoWebm,
    videoRatio: 1.756363636,
    duration: 12,
  },
  {
    title: { en: 'FEEDBACK & INSIGHTS', fr: 'GESTION DES RETOURS UTILISATEURS', de: 'FEEDBACK & ERKENNTNISSE' },
    description: {
      en: 'Listen to your customers <br class="hide-on-medium" /> and solve the right problems',
      fr: `Écoutez vos clients et ${
        isMobile(videoGalleryBreakPoint) && isDesktop(breakpoints.medium + 1) ? 'livrer' : 'apportez'
      } <br class="hide-on-medium" /> une solution à leurs problèmes`,
      de: 'Höre deinen Kunden zu <br class="hide-on-medium" /> und löse die richtigen Probleme',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/insights/', fr: '/fr/product/insights/', de: '/de/product/insights/' },
    mp4VideoSrc: insightsVideoMP4,
    webmVideoSrc: insightsVideoWebm,
    videoRatio: 1.756363636,
    duration: 11.5,
  },
  {
    title: { en: 'PORTAL', fr: 'PORTAIL', de: 'PORTAL' },
    description: {
      en: 'Engage with users <br class="hide-on-medium" /> on a branded portal',
      fr: 'Engagez vos utilisateurs <br class="hide-on-medium" /> sur un portail personnalisé',
      de: 'Sei über das Portal im <br class="hide-on-medium" /> Kontakt mit deinen Nutzenden',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/portal/', fr: '/fr/product/portal/', de: '/de/product/portal/' },
    mp4VideoSrc: portalVideoMP4,
    webmVideoSrc: portalVideoWebm,
    videoRatio: 1.756363636,
    duration: 9.38,
  },
]

export const airfocusWayVideos: GalleryVideoItemProps[] = [
  {
    title: {
      en: 'You need a dedicated area for each of <br class="hide-on-small-medium-large" /> your teams or products?',
      fr: "Besoin d'un espace dédié pour chaque <br class='hide-on-medium-large-desktop' /> produit et équipe ?",
      de: "Du brauchst einen Bereich für jedes <br class='hide-on-medium-large-desktop' /> Team oder Produkt?",
    },
    description: {
      en: `Spin up as many interconnected workspaces ${isDesktop(1030) && '<br />'} as you need.`,
      fr: "Créez autant d'espaces de travail <br class='hide-on-medium-large-desktop' /> que vous le souhaitez.",
      de: "Erstelle so viele verbundene Workspaces <br class='hide-on-medium-large-desktop' /> wie du brauchst.",
    },
    mp4VideoSrc: portfolioVideoMP4,
    webmVideoSrc: portfolioVideoWebm,
    videoRatio: 1.55,
    duration: 6.82,
  },
  {
    title: {
      en: 'You need to see your board as a timeline?',
      fr: 'Besoin de voir vos échéances produits <br class="hide-on-medium-large-desktop" /> sous forme chronologique ?',
      de: "Du möchtest dein Board <br class='hide-on-medium-large-desktop' /> als Timeline sehen?",
    },
    description: {
      en: 'Just add a new view for the same data.',
      fr: "Il vous suffit d'ajouter une nouvelle vue afin de mieux visualiser vos données.",
      de: "Füge einfach eine neue Ansicht <br class='hide-on-medium-large-desktop' /> der selben Daten hinzu.",
    },
    mp4VideoSrc: timelineBoardVideoMP4,
    webmVideoSrc: timelineBoardVideoWebm,
    videoRatio: 1.55,
    duration: 8,
  },
  {
    title: {
      en: 'You need a way to group your features?',
      fr: 'Besoin de regrouper vos fonctionnalités <br class="hide-on-medium-large-desktop" /> de manière simple et accessible ?',
      de: 'Du musst deine Features gruppieren?',
    },
    description: {
      en: 'Simply configure a custom field to do that.',
      fr: 'Vous pouvez facilement configurer <br class="hide-on-medium-large-desktop" /> des champs personnalisés.',
      de: 'Erstell Dir einfach ein Feld dafür.',
    },
    mp4VideoSrc: groupFeaturesVideoMP4,
    webmVideoSrc: groupFeaturesVideoWebm,
    videoRatio: 1.55,
    duration: 6.03,
  },
  {
    title: {
      en: 'You need a custom roadmap for C-level?',
      fr: "Besoin d'une roadmap personnalisée <br class='hide-on-medium-large-desktop' /> pour votre comité éxecutif ?",
      de: 'Du brauchst eine Roadmap nur fürs C-Level?',
    },
    description: {
      en: 'Generate around a dynamic & secure <br class="hide-on-small-medium-large" /> share link in seconds.',
      fr: 'Générez un lien de partage dynamique et sécurisé en quelques secondes.',
      de: "Erstelle einen dynamischen, sicheren Link <br class='hide-on-medium-large-desktop' /> zum Teilen in Sekunden.",
    },
    mp4VideoSrc: roadmapViewsVideoMP4,
    webmVideoSrc: roadmapViewsVideoWebm,
    videoRatio: 1.55,
    duration: 6.99,
  },
  {
    title: {
      en: 'You need an inclusive way to prioritize?',
      fr: "Besoin d'une méthode de priorisation <br class='hide-on-medium-large' /> ouverte à tous ?",
      de: "Du brauchst einen inklusiven Weg <br class='hide-on-medium-large-desktop' /> zur Priorisierung?",
    },
    description: {
      en: 'Extend your workspace with the <br class="hide-on-small-medium-large" /> Priority Poker app.',
      fr: 'Ajoutez notre application Priority Poker <br class="hide-on-medium-large-desktop" /> sur votre espace de travail.',
      de: "Erweitere deinen Workspace mit der <br class='hide-on-medium-large-desktop' /> Priority Poker App.",
    },
    mp4VideoSrc: prioritizeInclusiveVideoMP4,
    webmVideoSrc: prioritizeInclusiveVideoWebm,
    videoRatio: 1.55,
    duration: 8.052,
  },
]

export const homepageFeaturesGalleryContent: GalleryVideoItemProps[] = [
  {
    title: { en: 'ROADMAPS', fr: 'ROADMAPS', de: 'ROADMAPS' },
    description: {
      en: 'Build tailored roadmaps for every product and team. Create custom <br class="hide-on-small hide-on-large-desktop" /> views and share seamlessly with diverse audiences.',
      fr: 'Construisez des roadmaps personnalisées pour chaque produit et équipe. <br class="hide-on-small hide-on-large-desktop" /> Créez des vues différentes pour chacune de vos audiences pour <br class="hide-on-small hide-on-large-desktop" /> assurer une communication claire.',
      de: 'Erstellt maßgeschneiderte Roadmaps für jedes Produkt und jedes Team. <br class="hide-on-small hide-on-large-desktop" /> Entwickelt individuelle Ansichten und teilt sie reibungslos <br class="hide-on-small hide-on-large-desktop" /> mit verschiedenen Stakeholdern.',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/roadmaps/', fr: '/fr/product/roadmaps/', de: '/de/product/roadmaps/' },
    mp4VideoSrc: roadmapsVideoMP4,
    webmVideoSrc: roadmapsVideoWebm,
    videoRatio: 1.756363636,
    duration: 7.52,
  },
  {
    title: {
      en: 'PORTFOLIO MANAGEMENT',
      fr: 'GESTION DE PORTEFEUILLES <span class="hide-on-small">DE PRODUITS</span>',
      de: 'PORTFOLIO MANAGEMENT',
    },
    description: {
      en: 'Roll up any number of roadmaps into high-level portfolio views <br class="hide-on-small hide-on-large-desktop" /> and align stakeholders on big-picture strategy.',
      fr: 'Aggrégez autant de roadmaps que vous le désirez en une vue hélicoptère et <br class="hide-on-small hide-on-large-desktop" /> alignez les parties prenantes sur la stratégie. ',
      de: 'Fasst eine beliebige Anzahl von Roadmaps zu übergeordneten Portfolio-<br class="hide-on-small hide-on-large-desktop" />Ansichten zusammen und stimmt eure Stakeholder <br class="hide-on-small hide-on-large-desktop" /> auf eine ganzheitliche Strategie ab.',
    },
    withoutBorder: true,
    mp4VideoSrc: portfolioVideoMP4,
    webmVideoSrc: portfolioVideoWebm,
    videoRatio: 1.55,
    duration: 6.82,
  },
  {
    title: { en: 'FEEDBACK & INSIGHTS', fr: 'GESTION DES RETOURS UTILISATEURS', de: 'FEEDBACK & ERKENNTNISSE' },
    description: {
      en: 'Capture and centralize feedback to uncover insights. Understand <br class="hide-on-small hide-on-large-desktop" /> customer needs and solve the right problem.',
      fr: 'Capturez et centralisez les retours utilisateurs pour identifier de nouvelles <br class="hide-on-small hide-on-large-desktop" /> opportunités. Comprenez les besoins de vos clients et <br class="hide-on-small hide-on-large-desktop" /> résolvez les vrais problèmes.',
      de: 'Erfasst und zentralisiert Feedback, um neue Erkenntnisse zu gewinnen. <br class="hide-on-small hide-on-large-desktop" /> Versteht die Bedürfnisse eurer Kunden und löst die richtigen Probleme.',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/insights/', fr: '/fr/product/insights/', de: '/de/product/insights/' },
    mp4VideoSrc: insightsVideoMP4,
    webmVideoSrc: insightsVideoWebm,
    videoRatio: 1.756363636,
    duration: 11.5,
  },
  {
    title: { en: 'PRIORITIZATION', fr: 'PRIORISATION', de: 'PRIORISIERUNG' },
    description: {
      en: 'Align stakeholder inputs for smarter decisions. Simplify prioritization <br class="hide-on-small hide-on-large-desktop" /> and build products that meet market needs.',
      fr: 'Alignez les contributions des parties prenantes pour prendre de meilleures <br class="hide-on-small hide-on-large-desktop" /> décisions. Simplifiez la priorisation et construisez des produits qui <br class="hide-on-small hide-on-large-desktop" /> répondent aux besoins du marché.',
      de: 'Stimmt den Input eurer Stakeholder ab, um smartere Entscheidungen zu treffen - <br class="hide-on-small hide-on-large-desktop" /> vereinfacht die Priorisierung und entwickelt Produkte, die den <br class="hide-on-small hide-on-large-desktop" /> Marktanforderungen entsprechen.',
    },
    linkText: common.learnMoreText,
    linkURL: { en: '/product/prioritization/', fr: '/fr/product/prioritization/', de: '/de/product/prioritization/' },
    mp4VideoSrc: prioritizationVideoMP4,
    webmVideoSrc: prioritizationVideoWebm,
    videoRatio: 1.756363636,
    duration: 12,
  },
  {
    title: {
      en: 'OBJECTIVES & OKRs',
      fr: 'OBJECTIFS & OKRs',
      de: 'OBJECTIVES & OKRs',
    },
    description: {
      en: 'Keep your OKRs, roadmaps, and product workflows <br class="hide-on-small hide-on-large-desktop" /> interconnected to drive team alignment.',
      fr: "Gardez vos ORKs, roadmaps, et flux de travail connectés pour <br class='hide-on-small hide-on-large-desktop' />  améliorer l'alignement des équipes.",
      de: 'Verknüpft eure OKRs, Roadmaps und Produkt-Workflows, um die <br class="hide-on-small hide-on-large-desktop" /> Zusammenarbeit in euren Teams zu fördern.',
    },
    linkText: common.learnMoreText,
    linkURL: {
      en: '/product/objectives-okrs/',
      fr: '/fr/product/objectives-okrs/',
      de: '/de/product/objectives-okrs/',
    },
    mp4VideoSrc: okrVideoMP4,
    webmVideoSrc: okrVideoWebm,
    videoRatio: 1.756363636,
    duration: 14.085,
  },
  {
    title: { en: 'CAPACITY PLANNING', fr: 'ALLOCATION DES RESSOURCES', de: 'CAPACITY PLANNING' },
    description: {
      en: 'Easy resource management: plan scenarios and manage capacity <br class="hide-on-small hide-on-large-desktop" /> aligned with priorities and product strategy.',
      fr: 'Allouez vos ressources facilement : plannifiez différents scénarios et alignez <br class="hide-on-small hide-on-large-desktop" /> votre capacité aux priorités et à la stratégie produit.',
      de: 'Einfaches Ressourcenmanagement: Plant Szenarien und verwaltet Kapazitäten <br class="hide-on-small hide-on-large-desktop" /> passend zu euren Prioritäten und eurer Produktstrategie.',
    },
    linkText: common.learnMoreText,
    linkURL: {
      en: '/product/capacity-planning/',
      fr: '/product/capacity-planning/',
      de: '/product/capacity-planning/',
    },
    imgSrc: 'features/capacity-planning/capacity-planning.webp',
    mp4VideoSrc: '',
    webmVideoSrc: '',
    videoRatio: 1,
    duration: 7,
  },
]
